export class Constants {
  static dateOfBirthInvalidDay = 'please enter a valid day';
  static dateOfBirthInvalidMonth = 'please enter a valid month';
  static dateOfBirthInvalidYear = 'please enter a valid year';
  static dateOfBirthInvalidDate = 'please enter a valid date';
}
